import { render, staticRenderFns } from "./WeeklyProjectionDashboard.vue?vue&type=template&id=39a931af&scoped=true"
import script from "./WeeklyProjectionDashboard.vue?vue&type=script&lang=js"
export * from "./WeeklyProjectionDashboard.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProjectionDashboard.vue?vue&type=style&index=0&id=39a931af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a931af",
  null
  
)

export default component.exports